module.exports = __webpack_public_path__ + "static/media/400113_02.cb00c495.png";